import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";

const HowItWorks = () => {
  const { t } = useLang();
  const steps = [1, 2, 3, 4];
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="font-heading text-3xl sm:text-5xl font-extrabold text-navy tracking-tight">{t("howItWorks")}</h1>
      <p className="mt-3 text-navy/60 max-w-lg">{t("slogan")}</p>

      <div className="mt-10 space-y-4">
        {steps.map((n) => (
          <div key={n} className="flex gap-5 p-6 rounded-2xl bg-white border border-navy/10 items-start">
            <div className="w-12 h-12 rounded-full bg-coral text-white font-bold flex items-center justify-center shrink-0 text-xl">{n}</div>
            <div>
              <h3 className="font-heading font-bold text-navy text-xl">{t(`hiwStep${n}Title`)}</h3>
              <p className="text-navy/70 mt-1">{t(`hiwStep${n}Desc`)}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-10 text-center">
        <Link to="/restaurants"><Button className="btn-coral h-12 px-10" data-testid="hiw-order-btn">{t("orderFood")}</Button></Link>
      </div>
    </div>
  );
};

export default HowItWorks;
